"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Icons = void 0;
var react_1 = __importDefault(require("react"));
var configs = __importStar(require("./configs"));
var Bottom_1 = __importDefault(require("./Bottom"));
var FooterContent_1 = __importDefault(require("./FooterContent"));
var Header_1 = __importDefault(require("./Header"));
var MobileFooter_1 = __importDefault(require("./MobileFooter"));
var style_1 = require("./style");
var getConfig = function (cultureCode, countryCode) {
    var wantedConfig = "" + cultureCode + countryCode;
    switch (wantedConfig) {
        case 'deAT':
            return configs.deAT;
        case 'deDE':
            return configs.deDE;
        case 'esES':
            return configs.esES;
        case 'frBE':
            return configs.frBE;
        case 'frFR':
            return configs.frFR;
        case 'frLU':
            return configs.frLU;
        case 'itIT':
            return configs.itIT;
        case 'nlBE':
            return configs.nlBE;
        case 'nlNL':
            return configs.nlNL;
    }
    return configs.frFR;
};
var VPFooter = function (_a) {
    var _b, _c;
    var className = _a.className, countryCode = _a.countryCode, cultureCode = _a.cultureCode, externalConfig = _a.externalConfig, _d = _a.isLarge, isLarge = _d === void 0 ? false : _d, Logo = _a.Logo;
    var config = externalConfig !== null && externalConfig !== void 0 ? externalConfig : getConfig(cultureCode, countryCode);
    if (!isLarge) {
        return (react_1.default.createElement(MobileFooter_1.default, { className: className, mobile: config.mobile }));
    }
    return (react_1.default.createElement(style_1.Wrapper, { className: className, id: 'footer' },
        react_1.default.createElement("div", { className: 'Footer__innerWrapper' },
            react_1.default.createElement(Header_1.default, { apps: (_b = config === null || config === void 0 ? void 0 : config.header) === null || _b === void 0 ? void 0 : _b.apps, social: (_c = config === null || config === void 0 ? void 0 : config.header) === null || _c === void 0 ? void 0 : _c.social }),
            react_1.default.createElement(FooterContent_1.default, { columns: config.columns }),
            react_1.default.createElement(Bottom_1.default, { awards: config.awards, flagCode: config.flag, logoSubtitle: config.logoSubtitle, ProvidedLogo: Logo }))));
};
VPFooter.displayName = 'VPFooter';
exports.default = VPFooter;
exports.Icons = __importStar(require("./Icons"));
__exportStar(require("./types"), exports);
